import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import type { TeamSkillEntry, UserKnowledge } from '../../services/api.service';
import { Tooltip } from 'primeng/tooltip';
import { NgClass, NgIf, NgStyle } from '@angular/common';
import { TableModule } from 'primeng/table';


@Component({
  selector: 'app-skillmap-panel',
  standalone: true,
  imports: [Tooltip, NgClass, NgIf, NgStyle, TableModule],
  templateUrl: './skillmap-panel.component.html',
  styleUrl: './skillmap-panel.component.scss',
})

export class SkillmapPanelComponent implements OnChanges {
  @Input() selectedDataLabel = '';
  @Output() closePanel = new EventEmitter<void>();
  @Input() data!: UserKnowledge[];
  userLength = 0;
  @Input() teamSkillData?: TeamSkillEntry;

  onCloseClick() {
    this.closePanel.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.userLength = this.data.length;
  }

  getInitials(name: string): string {
    if (!name) return '';

    const parts = name.split(' ');
    const initials = (parts[0]?.charAt(0) || '') + (parts[1]?.charAt(0) || '');

    return initials.toUpperCase();
  }

  getIcon(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const icons: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'fa-check',
        '2': 'fa-xmark',
        '3': 'fa-minus',
      },
      like: {
        '1': 'fa-check',
        '2': 'fa-xmark',
        '3': 'fa-minus',
      },
      teaching_learning: {
        '0': 'fa-person-chalkboard',
        '1': 'fa-graduation-cap',
        '2': 'fa-minus',
      },
    };

    return icons[category]?.[String(value)] || 'fa-solid fa-minus';
  }

  getColor(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const colors: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'p-badge-success',
        '2': 'p-badge-error',
        '3': 'p-badge-undefined',
      },
      like: {
        '1': 'p-badge-success',
        '2': 'p-badge-error',
        '3': 'p-badge-undefined',
      },
      teaching_learning: {
        '0': 'p-badge-info',
        '1': 'p-badge-info',
        '2': 'p-badge-undefined',
      },
    };

    return colors[category]?.[String(value)] || 'p-badge-undefined';
  }

  getTooltipLabel(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const colors: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'Conosco',
        '2': 'Non conosco',
        '3': 'Non lo so',
      },
      like: {
        '1': 'Interessato',
        '2': 'Non interessato',
        '3': 'Non lo so',
      },
      teaching_learning: {
        '0': 'Disponibile come mentore',
        '1': 'Desideroso di imparare',
        '2': 'Indifferente',
      },
    };
    return colors[category]?.[String(value)] || 'Non definito';
  }
}
